import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"
import { useInView } from "react-intersection-observer"

import { useAppData } from "~/api/globals"
import { Title } from "~/components/Helpers/Title/Title"
import { useExportMagLang } from "~/components/LanguageProvider/LanguageProvider"
import { useWindowSize } from "~/services/useWindowSize"

import { ContactsInfo } from "../ContactsInfo/ContactsInfo"
import { SocialIcons } from "../SocialIcons/SocialIcons"
import { FooterAnimation } from "./components/FooterAnimation/FooterAnimation"
import styles from "./index.module.css"

export const Footer = ({ grayFooter = undefined, showBriefButton = undefined }) => {
  const context = useAppData()
  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang ? exportMagLang : i18n.language

  const [ref, inView] = useInView()

  const { width } = useWindowSize()
  const showAnimation = width > 1023

  if (!context || !context.contacts || context.contacts.length === 0) {
    return null
  }

  const { contacts } = context

  return (
    <div ref={ref} className={cn(styles.Wrapper, { [styles.GrayWrapper]: grayFooter })}>
      <div className="bb-container">
        <div className={styles.Content}>
          <div className="row">
            <div className="col-sm-10 col-md-8 col-xl-6">
              <Title className={styles.FooterTitle} type="h2">
                {contacts.heading[currLang]}
              </Title>
              <div className="lead">
                <ContactsInfo showBriefButton={!showBriefButton} isFooter>
                  <ContactsInfo.Contact>
                    <div className={styles.ContactsTitle}>{contacts.ekb[currLang]}</div>
                    {/* TODO: пока скрываем телефон ЕКБ Home */}
                    {/* <a href={`tel:${contacts.phoneAdditional.href}`}>
                      {contacts.phoneAdditional.text}
                    </a>
                    <br /> */}
                    <div dangerouslySetInnerHTML={{ __html: contacts.address[currLang] }} />
                  </ContactsInfo.Contact>
                </ContactsInfo>
              </div>

              <SocialIcons
                classNameIcon={styles.SocialIconsIcon}
                classNameWraper={styles.SocialIconsWrapper}
              />

              <div
                className={styles.Copyright}
                dangerouslySetInnerHTML={{ __html: contacts.footer[currLang] }}
              />
            </div>

            <div className="col-md-4 col-xl-6">
              <div className={styles.Illustration}>
                {showAnimation && <FooterAnimation isPaused={!inView} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
